import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { filter } from 'lodash';
import { ProfileContext } from 'context';
import { useAction, useProgressSuccess } from 'hooks';
import CloudDrive from 'modules/CloudDrive';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import { sortByNoteType } from '../../components/VisitNotes/helpers';
import VisitNotes from './VisitNotes';
const VisitNotesMessenger = ({ phisetVisitId, mode, isMobile, onStoreNotes })=>{
    const profileContext = useContext(ProfileContext);
    const activePatient = useSelector(profileContext.selectors.activePatient);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    const notes = useSelector(profileContext.selectors.notes);
    const phiSetDocumentId = useSelector(profileContext.selectors.phiSetDocumentId);
    const visits = useSelector(selectors.visits);
    const isResetNewMessagesInProgress = useSelector(CloudDrive.selectors.isResetNewMessagesInProgress);
    const hasResetNewMessagesErrors = useSelector(CloudDrive.selectors.hasResetNewMessagesErrors);
    const visit = visits.find((v)=>v.phisetVisitId === phisetVisitId);
    const phiVisit = phiSet.visits.find((pv)=>pv.phisetVisitId === phisetVisitId);
    const { setPhiSet } = profileContext.actions;
    const resetNewMessages = useAction(CloudDrive.actions.resetNewMessages, phiSet, phiSetDocumentId, phisetVisitId, activePatient, setPhiSet);
    const setVisitData = useAction(actions.setVisitData);
    const onSetVisitData = useCallback(()=>{
        setVisitData(phiVisit);
    }, [
        phiVisit
    ]);
    useProgressSuccess(isResetNewMessagesInProgress, hasResetNewMessagesErrors, onSetVisitData);
    const filteredNotes = filter(notes, {
        phisetVisitId
    }).sort(sortByNoteType);
    const hcpProfile = visit.metadata.createdBy;
    useEffect(()=>{
        if (phiVisit.newMessages) {
            resetNewMessages();
        }
    }, []);
    return /*#__PURE__*/ _jsx(VisitNotes, {
        visit: visit,
        notes: filteredNotes,
        mode: mode,
        phiSet: phiSet,
        phiSetDocumentId: phiSetDocumentId,
        pwdAvatar: activePatient,
        hcpAvatar: hcpProfile,
        isMobile: isMobile,
        isReplyNoteFormWithActionButtons: true,
        onStoreNotes: onStoreNotes
    });
};
export default VisitNotesMessenger;
